// import React from "react";
// import { whiteLogo } from "../icons/white-logo";
// import { whatsapp } from "../icons/whatsapp";
// import { facebook } from "../icons/facebook";
// import { Link } from "react-router-dom";

// function Footer() {
//   const translateToEnglish = () => {
//     const select = document.querySelector(".goog-te-combo");
//     if (select) {
//       select.value = "en";
//       select.dispatchEvent(new Event("change"));
//     }
//   };

//   const resetToArabic = () => {
//     // Remove google translate cookies
//     document.cookie = "googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
//     document.cookie = "googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=" + window.location.hostname + ";";

//     // Reload page to restore original Arabic content
//     window.location.reload();
//   };


//   return (
//     <div className=" w-full h-fit lg:h-[24rem]">
//       <div className="bg-mobile-footer-background lg:bg-footer-background bg-cover bg-center h-full ">
//         <div className=" text-white flex flex-col lg:flex-row py-10 lg:py-0 lg:justify-between lg:items-center  h-full px-20 ">
//           <div className="flex flex-col lg:flex-row gap-20 lg:gap-44 text-xl lg:text-2xl">
//             <div className="lg:flex flex-col hidden gap-10">
//               <span className="mx-auto">{whiteLogo}</span>© Copyright Acts
//             </div>
//             <div className="flex flex-col gap-2 text-center">
//               <span className="text-lg text-gray-400">القائمة</span>
//               <Link to={"/home/cropsOffers"}>
//                 <span>المحاصيل</span>
//               </Link>

//               <Link to={"/home/services"}>
//                 <span>الخدمات</span>
//               </Link>

//               <Link to={"/home/prices"}>
//                 <span>الأسعار</span>
//               </Link>

//               <Link to={"/home/weather"}>
//                 <span>الطقس</span>
//               </Link>

//               <Link to={"/home/profile"}>
//                 <span>حسابي</span>
//               </Link>
//             </div>
//             <div className="flex flex-col  gap-2 text-center">
//               <Link to={"/home/about"}>
//                 <span>من نحن</span>
//               </Link>
//               <Link to={"/home/privacy-policy"}>
//                 <span>الخصوصية</span>
//               </Link>
//               <Link to={"/home/terms"}>
//                 <span>ضوابط الإستخدام</span>
//               </Link>

//             </div>
//           </div>
//           <div className="flex gap-3 flex-col items-center mt-20 lg:my-0 lg:items-end">
//             <div className="flex gap-3 mt-6 justify-center lg:justify-end">
//               <button
//                 onClick={translateToEnglish}
//                 className="px-3 py-1 bg-white/20 rounded hover:bg-white/30 transition"
//               >
//                English
//               </button>

//               <button
//                 onClick={resetToArabic}
//                 className="px-3 py-1 bg-white/20 rounded hover:bg-white/30 transition"
//               >
//                 العربية
//               </button>
//             </div>

//             <p className="text-center text-2xl"> إتصل بنا على الرقم المختصر</p>
//             <a className="text-9xl" href="tel:3623">
//               {" "}
//               3623
//             </a>
//             <div className="text-2xl">
//               <button
//                 onClick={() => (window.location = "mailto:info@mahsool.sd")}
//               >
//                 info@mahsool.sd
//               </button>
//             </div>
//             <div className="flex gap-3">
//               <a href="https://wa.me/message/K5BD6QOI2BBYE1" target="_blank">
//                 <p className="p-3 bg-white/10 rounded-full hover:scale-105 hover:shadow-white hover:shadow-md transition-all">
//                   {whatsapp}
//                 </p>
//               </a>
//               <a
//                 href="https://www.facebook.com/profile.php?id=100089265053519&mibwxtid=ZbWKwL"
//                 target="_blank"
//               >
//                 <p className="p-3 bg-white/10 rounded-full  hover:scale-105 hover:shadow-white hover:shadow-md transition-all">
//                   {facebook}
//                 </p>
//               </a>
//             </div>
//             <div className="flex flex-col mt-10 lg:hidden gap-10">
//               <span className="mx-auto">{whiteLogo}</span>© Copyright Acts
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Footer;
import React, { useState, useEffect } from "react";
import { whiteLogo } from "../icons/white-logo";
import { whatsapp } from "../icons/whatsapp";
import { facebook } from "../icons/facebook";
import { Link } from "react-router-dom";

function Footer() {
  const [currentLang, setCurrentLang] = useState('ar');

  useEffect(() => {
    const checkLanguage = () => {
      const select = document.querySelector('.goog-te-combo');
      if (select && select.value === 'en') {
        setCurrentLang('en');
      } else {
        setCurrentLang('ar');
      }
    };

    checkLanguage();
    const observer = new MutationObserver(checkLanguage);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  const toggleLanguage = () => {
    const select = document.querySelector('.goog-te-combo');
    if (select) {
      if (currentLang === 'ar') {
        // Switch to English
        select.value = 'en';
        setCurrentLang('en');
        select.dispatchEvent(new Event('change'));
      } else {
        // Switch back to Arabic - clear cookies and reload
        document.cookie = "googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        document.cookie = "googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=" + window.location.hostname + ";";
        document.cookie = "googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=." + window.location.hostname + ";";
        
        // Force page reload to restore Arabic
        window.location.reload();
      }
    }
  };

  return (
    <div className="w-full h-fit lg:h-[24rem]">
      <div className="bg-mobile-footer-background lg:bg-footer-background bg-cover bg-center h-full">
        <div className="text-white flex flex-col lg:flex-row py-10 lg:py-0 lg:justify-between lg:items-center h-full px-20">
          <div className="flex flex-col lg:flex-row gap-20 lg:gap-44 text-xl lg:text-2xl">
            <div className="lg:flex flex-col hidden gap-10">
              <span className="mx-auto">{whiteLogo}</span>© Copyright Acts
            </div>
            <div className="flex flex-col gap-2 text-center">
              <span className="text-lg text-gray-400">القائمة</span>
              <Link to={"/home/cropsOffers"}>
                <span>المحاصيل</span>
              </Link>
              <Link to={"/home/services"}>
                <span>الخدمات</span>
              </Link>
              <Link to={"/home/prices"}>
                <span>الأسعار</span>
              </Link>
              <Link to={"/home/weather"}>
                <span>الطقس</span>
              </Link>
              <Link to={"/home/profile"}>
                <span>حسابي</span>
              </Link>
            </div>
            <div className="flex flex-col gap-2 text-center">
              <Link to={"/home/about"}>
                <span>من نحن</span>
              </Link>
              <Link to={"/home/privacy-policy"}>
                <span>الخصوصية</span>
              </Link>
              <Link to={"/home/terms"}>
                <span>ضوابط الإستخدام</span>
              </Link>
            </div>
          </div>
          
          <div className="flex gap-3 flex-col items-center mt-20 lg:my-0 lg:items-end">
            {/* Single toggle button - shows opposite language */}
            <button
              onClick={toggleLanguage}
              className="flex items-center gap-2 px-4 py-2 bg-white/20 rounded-lg hover:bg-white/30 transition-all duration-300 hover:scale-105"
            >
              {currentLang === 'ar' ? (
                <>
                  <span className="text-sm font-medium">English</span>
                </>
              ) : (
                <>
                  <span className="text-sm font-medium">العربية</span>
                </>
              )}
            </button>

            <p className="text-center text-2xl mt-4">إتصل بنا على الرقم المختصر</p>
            <a className="text-9xl hover:scale-110 transition-transform" href="tel:3623">
              3623
            </a>
            <div className="text-2xl">
              <button
                onClick={() => (window.location = "mailto:info@mahsool.sd")}
                className="hover:underline"
              >
                info@mahsool.sd
              </button>
            </div>
            <div className="flex gap-3 mt-2">
              <a href="https://wa.me/message/K5BD6QOI2BBYE1" target="_blank" rel="noopener noreferrer">
                <p className="p-3 bg-white/10 rounded-full hover:scale-110 hover:shadow-white hover:shadow-md transition-all">
                  {whatsapp}
                </p>
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=100089265053519&mibwxtid=ZbWKwL"
                target="_blank"
                rel="noopener noreferrer"
              >
                <p className="p-3 bg-white/10 rounded-full hover:scale-110 hover:shadow-white hover:shadow-md transition-all">
                  {facebook}
                </p>
              </a>
            </div>
            <div className="flex flex-col mt-10 lg:hidden gap-10">
              <span className="mx-auto">{whiteLogo}</span>© Copyright Acts
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;